projects_map_pedestrian_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        properties.currentID = '';
        mapData.selectLayer.clearLayers();
        geojson_loader_handler.removeData();
        // geojson_loader_handler.loadData('transit');
        // geojson_loader_handler.loadData('bike');
        geojson_loader_handler.fetch({
          label: 'pedestrian',
          url: 'pedestrian',
          mapView: 'pedestrian',
          source: 'data/burlingame/ped_recs.json',
          dataType: "point",
          style: {
            color: '#444',
            weight: 5,
            opacity: 1,
            className: 'pedestrian-recommendations',
          },
        });

        $('body').addClass('secondary-bg');
        
    },

    events: function() {
        var self = this;
        self.onLoad();

        $('.start-btn').click(function(event) {
        	$('#content-root, #map').toggleClass('swipe');
            if ($('#content-root').hasClass('swipe') == true){
                home_handler.scrollTop();
            }
            else {
                home_handler.scrollContent();
            }
            setTimeout(resizeMap, 150);
            return false;
        });
    }
}
